import React, { useState } from 'react';
import {
    Button,
    Grid,
    Paper,
    TextField,
    Box,
    Typography
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate, useParams } from 'react-router-dom';
import { Token } from '@mui/icons-material';
import { decodeJWT, getToken } from '../../utils/utils';
import { changePassword } from './api';
const ChangePassword: React.FC = () => {
         const { emailid } = useParams();
const token = getToken();
 const navigate = useNavigate();
      const decodedToken = decodeJWT(token);
      console.log(decodedToken, "Decoded token");
            const mainemail = decodedToken?.email;


    const [email, setEmail] = useState(mainemail ?? '');


   
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const validateEmail = (value: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        return regex.test(value);
    };

    const isError = isSubmitted && !validateEmail(email);
console.log(emailid, "emailidssssssssss7777777")
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setIsSuccess(false); // Reset success on change
    };

const handleSubmit = async () => {
  try {
    const response = await changePassword({ email }, token);
    console.log(response, "eeeeeeeeeee");

    setIsSubmitted(true);

    if (validateEmail(email)) {
      console.log("Reset link sent to:", email);
      setIsSuccess(true);
      navigate(`/reset-link`);
    } else {
      setIsSuccess(false);
    }

  } catch (error) {
    console.error("Error sending reset link:", error);
    setIsSuccess(false);
  }
};


console.log(isSubmitted, "ssssssssssssssssss")
    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <img src="/logo-pmi.png" alt='logo' />

                    <Box sx={{ mt: 8, textAlign: "left", width: '440px' }}>
                        <Typography variant="h5" fontWeight="bold" fontSize="30px" color="#1976D2" gutterBottom>
                            Change Password
                        </Typography>
                        <Typography variant="body1" mb={3} fontSize="16px" color="#282829" fontWeight="500">
                            Enter your Username to receive the password reset link
                        </Typography>

                        <Typography variant="subtitle1" mb={1}>
                            Email Address<span style={{ color: "red" }}>*</span>
                        </Typography>

                        <TextField
                            fullWidth
                            placeholder="eg. xyz@gmail.com"
                            variant="outlined"
                            value={email}
                            onChange={handleChange}
                            error={isError}

                            helperText={
                                isError ? (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <InfoOutlinedIcon sx={{ color: '#E63946', fontSize: 18 }} />
                                        <span>Enter correct Email ID</span>
                                    </Box>
                                ) : isSuccess ? (
                                    <Typography sx={{ color: 'green', fontSize: 13 }}>✓ Success text</Typography>
                                ) : ""
                            }
                            sx={{
                                mb: 1,
                                fontSize: "16",
                                border: "none",
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: isError
                                        ? '#FFECEC'
                                        : isSuccess
                                            ? '#E6FAEA'
                                            : '#F9FBFC',
                                    borderRadius: '10px',
                                    '& fieldset': {
                                        border: "none",
                                        borderBottom: isError
                                            ? '1px solid #E63946'
                                            : isSuccess
                                                ? '1px solid #2ECC71'
                                                : 'none',
                                    },
                                    '&:hover fieldset': {
                                        border: isError
                                            ? '1px solid #E63946'
                                            : isSuccess
                                                ? '1px solid #2ECC71'
                                                : 'none',
                                    },
                                    '&.Mui-focused fieldset': {
                                        border: isError
                                            ? '1px solid #E63946'
                                            : isSuccess
                                                ? '1px solid #2ECC71'
                                                : 'none',
                                    },
                                },
                                '& .MuiFormHelperText-root': {
                                    color: isError ? '#E63946' : isSuccess ? '#2ECC71' : '',
                                    fontSize: '13px',
                                    marginLeft: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                },
                            }}
                        />

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={!email}
                            sx={{
                                backgroundColor: !email ? "#A9A9A9" : "#C8172F",
                                color: "white",
                                textTransform: "none",
                                borderRadius: 2,
                                py: 1.5,
                                boxShadow: 0,
                                fontSize: "14px",
                                lineHeight: 1.15,
                                mt: 2,
                            }}
                        >
                            Send Reset Link
                          
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ChangePassword;
